import mixpanel from 'mixpanel-browser';

import type { EventName } from '@/utils/mixpanel';

export const trackPreQualifyEvent = (
  dealId: string,
  eventName: EventName,
  properties?: Record<string, unknown>,
) => {
  mixpanel.identify(dealId);
  mixpanel.track(eventName, {
    timestamp: Date.now(),
    ...properties,
  });
};
